import React, { createContext } from 'react';
import HistoricalBox from '../../components/shared/historical/HistoricalBox';
import { IHistorical, ILog } from './model';

export type HistoricalCtxData<T extends ILog> = {
  historical?: IHistorical<T>;
  getLatestLogs?: () => void;
  getMoreLogs?: () => void;
  onRemoveLog?: (l: T) => void
};
/*
export type LogsCtxState<T extends ILog> = {
  data?: HistoricalCtxData<T>;
  setData?: (d: HistoricalCtxData<T>) => void
};*/

export const HistoricalCtx = createContext({});

type HistoricalCtxProviderType<T extends ILog> = {
  value: HistoricalCtxData<T>;
  children: any;
};
export const Historical = <T extends ILog>({
  value,
  children,
}: HistoricalCtxProviderType<T>) => {
  return (
    <HistoricalCtx.Provider value={value}>
      <HistoricalBox>{children}</HistoricalBox>
    </HistoricalCtx.Provider>
  );
};
